<template>
  <div id="app">
    <router-view></router-view>

  </div>

</template>

<script>

export default {
  name: 'app',
  data: function () {
    return {
      isMobile: false,
    }
  },
  methods: {
    // 检查是否是移动端
    checkIsMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if (flag) {
        this.replacePcUrl()
        if (this.$route.path.includes('m_indonesian_leadership_training') ||
          this.$route.path.includes('m_clec_chinese_smart_classroom') ||
          this.$route.path.includes('m_clec_partner') ||
          this.$route.path.includes('m_public_teacher_policy_interpretation') ||
          this.$route.path.includes('m_learn_chinese_language') ||
          this.$route.path.includes('m_storyofchina')
        ) {
          this.setHtmlFontSize(11.25)
        } else if (this.$route.path.includes('m_epidemic_training_public_teachers') || this.$route.path.includes('m_pakistan_class_live') || this.$route.path.includes('m_cmgp2025')) {
          this.setHtmlFontSize(10.8)
        }
        else {
          this.setHtmlFontSize(7.5)
        }
      } else {
        this.setHtmlFontSize(19.2)
        this.replaceMobileUrl()
      }
    },
    setHtmlFontSize(num) {
      //得到手机屏幕的宽度
      let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
      //得到html的Dom元素
      let htmlDom = document.getElementsByTagName('html')[0];
      //设置根元素字体大小
      htmlDom.style.fontSize = htmlWidth / num + 'px';

    },
    replacePcUrl() {
      var path = this.$route.path
      var toUrl = '/m_page/m_mainpage'
      switch (path) {
        case '/pcpage/mainpage':
          toUrl = '/m_page/m_mainpage'
          break;
        case '/pcpage/guide':
          toUrl = '/m_page/m_guide'
          break;
        case '/pcpage/chinesebridge':
          toUrl = '/m_page/m_chinesebridge'
          break;
        case '/pcpage/classlive':
          toUrl = '/m_page/m_classlive'
          break;
        case '/pcpage/chineseplus_classlive':
          toUrl = '/m_page/m_chineseplus_classlive'
          break;
        case '/pcpage/indonesian_leadership_training':
          toUrl = '/m_page/m_indonesian_leadership_training'
          break;
        case '/pcpage/epidemic_training_public_teachers':
          toUrl = '/m_page/m_epidemic_training_public_teachers'
          break;
        case '/pcpage/clec_chinese_smart_classroom':
          toUrl = '/m_page/m_clec_chinese_smart_classroom'
          break;
        case '/pcpage/clec_partner':
          toUrl = '/m_page/m_clec_partner'
          break;
        case '/pcpage/public_teacher_policy_interpretation':
          toUrl = '/m_page/m_public_teacher_policy_interpretation'
          break;
        case '/pcpage/learn_chinese_language':
          toUrl = '/m_page/m_learn_chinese_language'
          break;
        case '/pcpage/chineseplus_live2022':
          toUrl = '/m_page/m_chineseplus_live2022'
          break;
        case '/pcpage/chineseplus_live2023':
          toUrl = '/m_page/m_chineseplus_live2023'
          break;
        case '/pcpage/pakistan_class_live':
          toUrl = '/m_page/m_pakistan_class_live'
          break;
        case '/pcpage/indonesian_native_teacher_classA':
          toUrl = '/m_page/m_indonesian_native_teacher_classA'
          break;
        case '/pcpage/indonesian_native_teacher_classB':
          toUrl = '/m_page/m_indonesian_native_teacher_classB'
          break;
        case '/pcpage/indonesian_leadership_classC':
          toUrl = '/m_page/m_indonesian_leadership_classC'
          break;
        case '/pcpage/indonesian_leadership_classD':
          toUrl = '/m_page/m_indonesian_leadership_classD'
          break;
        case '/pcpage/storyofchina':
          toUrl = '/m_page/m_storyofchina'
          break;
        case '/pcpage/russia_business':
          toUrl = '/m_page/m_russia_business'
          break;
        case '/pcpage/cis_business':
          toUrl = '/m_page/m_cis_business'
          break;
        case '/pcpage/cis_business2024':
          toUrl = '/m_page/m_cis_business2024'
          break;
        case '/pcpage/cmgp':
          toUrl = '/m_page/m_cmgp'
          break;
        case '/pcpage/cmgp2025':
          toUrl = '/m_page/m_cmgp2025'
          break;
        case '/pcpage/cmgp2025_detail':
          toUrl = '/m_page/m_cmgp2025_detail'
          break;
        case '/pcpage/cmgp2026':
          toUrl = '/m_page/m_cmgp2026'
          break;
        case '/pcpage/cmgp2026_detail':
          toUrl = '/m_page/m_cmgp2026_detail'
          break;
        case '/pcpage/hm2025':
          toUrl = '/m_page/m_hm2025'
          break;
        case '/pcpage/hm2025_detail':
          toUrl = '/m_page/m_hm2025_detail'
          break;
        case '/pcpage/explanation_of_teacher_benefits':
          toUrl = '/m_page/m_explanation_of_teacher_benefits'
          break;
        case '/pcpage/iccb':
          toUrl = '/m_page/m_iccb'
          break;
        default:
          toUrl = path
          break;
      }
      this.$router.replace({
        path: toUrl,
        query: this.$route.query
      })
    },
    replaceMobileUrl() {
      var path = this.$route.path
      var toUrl = '/pcpage/mainpage'
      switch (path) {
        case '/m_page/m_mainpage':
          toUrl = '/pcpage/mainpage'
          break;
        case '/m_page/m_guide':
          toUrl = '/pcpage/guide'
          break;
        case '/m_page/m_guidedetail':
          toUrl = '/pcpage/guide'
          break;
        case '/m_page/m_chinesebridge':
          toUrl = '/pcpage/chinesebridge'
          break;
        case '/m_page/m_classlive':
          toUrl = '/pcpage/classlive'
          break;
        case '/m_page/m_chineseplus_classlive':
          toUrl = '/pcpage/chineseplus_classlive'
          break;
        case '/m_page/m_indonesian_leadership_training':
          toUrl = '/pcpage/indonesian_leadership_training'
          break;
        case '/m_page/m_indonesian_leadership_training_detail':
          toUrl = '/pcpage/indonesian_leadership_training'
          break;
        case '/m_page/m_epidemic_training_public_teachers':
          toUrl = '/pcpage/epidemic_training_public_teachers'
          break;
        case '/m_page/m_clec_chinese_smart_classroom':
          toUrl = '/pcpage/clec_chinese_smart_classroom'
          break;
        case '/m_page/m_clec_partner':
          toUrl = '/pcpage/clec_partner'
          break;
        case '/m_page/m_public_teacher_policy_interpretation':
          toUrl = '/pcpage/public_teacher_policy_interpretation'
          break;
        case '/m_page/m_learn_chinese_language':
          toUrl = '/pcpage/learn_chinese_language'
          break;
        case '/m_page/m_chineseplus_live2022':
          toUrl = '/pcpage/chineseplus_live2022'
          break;
        case '/m_page/m_pakistan_class_live':
          toUrl = '/pcpage/pakistan_class_live'
          break;
        case '/m_page/m_indonesian_native_teacher_classA':
          toUrl = '/pcpage/indonesian_native_teacher_classA'
          break;
        case '/m_page/m_indonesian_native_teacher_classB':
          toUrl = '/pcpage/indonesian_native_teacher_classB'
          break;
        case '/m_page/m_indonesian_leadership_classC':
          toUrl = '/pcpage/indonesian_leadership_classC'
          break;
        case '/m_page/m_indonesian_leadership_classD':
          toUrl = '/pcpage/indonesian_leadership_classD'
          break;
        case '/m_page/m_storyofchina':
          toUrl = '/pcpage/storyofchina'
          break;
        case '/m_page/m_russia_business':
          toUrl = '/pcpage/russia_business'
          break;
        case '/m_page/m_cis_business':
          toUrl = '/pcpage/cis_business'
          break;
        case '/m_page/m_cis_business2024':
          toUrl = '/pcpage/cis_business2024'
          break;
        case '/m_page/m_cmgp':
          toUrl = '/pcpage/cmgp'
          break;
        case '/m_page/m_cmgp2025':
          toUrl = '/pcpage/cmgp2025'
          break;
        case '/m_page/m_cmgp2025_detail':
          toUrl = '/pcpage/cmgp2025_detail'
          break;
        case '/m_page/m_hm2025':
          toUrl = '/pcpage/hm2025'
          break;
        case '/m_page/m_hm2025_detail':
          toUrl = '/pcpage/hm2025_detail'
          break;
        case '/m_page/m_iccb':
          toUrl = '/pcpage/iccb'
          break;
        case '/m_page/m_explanation_of_teacher_benefits':
          toUrl = '/pcpage/explanation_of_teacher_benefits'
          break;
        case '/m_page/m_cmgp2026':
          toUrl = '/pcpage/cmgp2026'
          break;
        case '/m_page/m_cmgp2026_detail':
          toUrl = '/pcpage/cmgp2026_detail'
          break;
        default:
          toUrl = path
          break;
      }
      this.$router.replace({
        path: toUrl,
        query: this.$route.query
      })
    },
  },
  mounted: function () {
    this.checkIsMobile()
    //监听屏幕尺寸变化
    window.addEventListener('resize', () => {
      this.checkIsMobile()
    })
  }
}
</script>

<style>
.z_width.el-message-box {
  width: 90% !important;
}

body {
  font-size: 16px;
}

/* html,body {
  width: 100%;
  height: 100%;
}
body {
  font-size: 18px;
  font-family: MicrosoftYaHei;
}
#app {
  width: 100%;
  height: 100%;
}

.clearfix:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;

} */
</style>
